export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5604.37c24967.jpg";